import React, { useEffect } from 'react';
import { withWrapper } from '@shared/react';
import {
    ClientDetailsTableProvider,
    useClientDetailsTable,
    getTransactionsTableColumns,
    UserManagement_TABLE_TITLE,
    UserManagement_TABLE_INFO_URL,
    getClientTableRows,
} from './lib';
import { Table } from '@features/Table';
import './ClientDetailsTable.scss';
import dropDownStore from './store/drop-down-table-store';
import { useNavigate } from 'react-router-dom';

const ClientDetailsTableContent: React.FC<{ userId: number; fromRIA: boolean }> = ({ userId, fromRIA }) => {
    const { ClientDetailsBody, paginationOptions, clientLoading } = useClientDetailsTable();

    const userStorage = localStorage.getItem('User');
    let userObject = JSON.parse(userStorage ? userStorage : '');

    const navigate = useNavigate();

    const onClientViewClick = (row: any) => {
        const userId = row?.userId || row?.id;
        if (userId) {
            navigate(`/preferences/${userId}`);
        }
    };

    useEffect(() => {
        return () => {
            dropDownStore.getState().clearRows(); // Clear Zustand store when unmounting
        };
    }, []);

    return (
        <Table
            columns={getTransactionsTableColumns(ClientDetailsBody, fromRIA)}
            data={ClientDetailsBody}
            dataLoading={clientLoading}
            tableTitle={userObject ? null : UserManagement_TABLE_TITLE}
            infoLink={UserManagement_TABLE_INFO_URL}
            paginationOptions={paginationOptions}
            row={getClientTableRows({ onClientViewClick })}
            showButton={true}
            noScroll={true}
            tableToShow='showTable'
        />
    );
};

export const ClientDetailsTable = withWrapper(ClientDetailsTableProvider)(ClientDetailsTableContent);
